import { NotificationType, OrderDomainSpecificErrorCode } from '@vista/omnichannel-components-domain';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
const getNotificationId = (context) => {
    return getIdForComponentNotification('gift-card-payment-form', NotificationType.Error, context);
};
export const getNotificationDetailsForError = (displayText, error) => {
    switch (error.errorCode) {
        case OrderDomainSpecificErrorCode.GiftCardCredentialsInvalid:
            return {
                id: getNotificationId('gift-card-credentials-invalid'),
                messages: [displayText.errorGiftCardCredentialsInvalidMessage]
            };
        case OrderDomainSpecificErrorCode.InsufficientGiftCardBalance:
            return {
                id: getNotificationId('insufficient-gift-card-balance'),
                messages: [displayText.errorInsufficientGiftCardBalanceMessage]
            };
        case OrderDomainSpecificErrorCode.GiftCardExpired:
            return {
                id: getNotificationId('gift-card-expired'),
                messages: [displayText.errorGiftCardExpiredMessage]
            };
        case OrderDomainSpecificErrorCode.GiftCardAlreadyAdded:
            return {
                id: getNotificationId('gift-card-already-added'),
                messages: [displayText.errorGiftCardAlreadyAddedMessage]
            };
        default:
            return {
                id: getNotificationId('failed-to-add'),
                messages: [displayText.errorFailedAddingGiftCardMessage]
            };
    }
};
